/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_InvoicesInputs */

const en_admin_dashboard_invoices = /** @type {(inputs: Admin_Dashboard_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoices`)
};

const de_admin_dashboard_invoices = /** @type {(inputs: Admin_Dashboard_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechnungen`)
};

const es_admin_dashboard_invoices = /** @type {(inputs: Admin_Dashboard_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturas`)
};

const fr_admin_dashboard_invoices = /** @type {(inputs: Admin_Dashboard_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Factures`)
};

const it_admin_dashboard_invoices = /** @type {(inputs: Admin_Dashboard_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fatture`)
};

const pt_br2_admin_dashboard_invoices = /** @type {(inputs: Admin_Dashboard_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faturas`)
};

const pl_admin_dashboard_invoices = /** @type {(inputs: Admin_Dashboard_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faktury`)
};

const hu_admin_dashboard_invoices = /** @type {(inputs: Admin_Dashboard_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Számlák`)
};

const ro_admin_dashboard_invoices = /** @type {(inputs: Admin_Dashboard_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturi`)
};

/**
* | output |
* | --- |
* | "Invoices" |
*
* @param {Admin_Dashboard_InvoicesInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_invoices = /** @type {((inputs?: Admin_Dashboard_InvoicesInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_InvoicesInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_invoices(inputs)
	if (locale === "de") return de_admin_dashboard_invoices(inputs)
	if (locale === "es") return es_admin_dashboard_invoices(inputs)
	if (locale === "fr") return fr_admin_dashboard_invoices(inputs)
	if (locale === "it") return it_admin_dashboard_invoices(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_invoices(inputs)
	if (locale === "pl") return pl_admin_dashboard_invoices(inputs)
	if (locale === "hu") return hu_admin_dashboard_invoices(inputs)
	return ro_admin_dashboard_invoices(inputs)
});
export { admin_dashboard_invoices as "admin.dashboard.invoices" }